<template>
  <div class="ly_appSize un_phoneView_wrapper __bgWhite hp_posiRel">
    <h1 class="blind">파드 리스트 페이지</h1>

    <!-- 모달 (바텀시트) -->
    <article class="bl_modal_wrapper __bottomSheet">
      <div class="bl_modal_dimed"></div>
      <div class="bl_modal">
        <section class="bl_modal_body __pb24">
          <div class="bl_modal_cont">
            <img src="/images/oeApp.svg" v-auto-title alt="코인 이미지" />
            <h2>앱에서 더 구경할 수 있어요<br />앱에서 볼까요?</h2>
          </div>
        </section>
        <section class="bl_modal_btnWrapper">
          <a class="el_btn" target="_blank" :href="useGetStoreLink()"
            >앱으로 보기</a
          >
          <button class="el_btn __light">닫기</button>
        </section>
      </div>
    </article>

    <!-- 탑 바 -->
    <header class="bl_topBar">
      <NuxtLink class="bl_topBar_logo" to="/"></NuxtLink>
      <div class="bl_topBar_nav">
        <NuxtLink to="/introduceOE">앱 소개</NuxtLink>
        <NuxtLink to="/gathering/list">취미 모임</NuxtLink>
      </div>
    </header>

    <h2 class="el_pageTitle">소통 공간</h2>
    <div class="un_feedList">
      <NuxtLink
        class="un_feedList_item"
        v-for="(feed, index) in getList"
        :key="index"
        :to="`/gathering/feed/${feed.id}`"
      >
        <figure class="un_feedList_imgWrapper">
          <CustomImage
            :src="
              typeof feed.image === 'string'
                ? feed.image
                : feed.image.thumbnailUrl
            "
            alt="피드 이미지"
          ></CustomImage>
          <i
            v-if="typeof feed.image === 'object'"
            class="un_feedList_playIc el_icon_size_56"
          ></i>
        </figure>
        <div class="un_feedList_desc">
          <figure class="el_profile hp_mb12">
            <!-- <img :src="feed.author.getImage" v-auto-title alt="유저 프로필" /> -->
            <CustomProfileImage
              :src="feed.author.image"
              v-auto-title
              alt="유저 프로필"
            ></CustomProfileImage>
            <figcaption>{{ feed.author.nickname }}</figcaption>
          </figure>
          <p>
            {{ feed.description }}
          </p>
          <div class="bl_reactionSection">
            <i class="bl_reaction __chat">{{ feed.commentCount }}</i>
            <i class="bl_reaction __heart">{{ feed.likeCount }}</i>
          </div>
        </div>
      </NuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useGetStoreLink } from "~/composable/useGetStoreLink";
import { useGatheringFeedListStore } from "../../../stores/gathering-feed-list";

const store = useGatheringFeedListStore();
const { getList, fetchedAll, offset } = storeToRefs(store);
const fetching = ref(false);
let removeBeforeEach: () => void;

const fetch = async () => {
  if (fetchedAll.value) {
    return;
  }
  if (fetching.value) {
    return;
  }
  fetching.value = true;
  return api
    .getGatheringFeedList(20, offset.value)
    .then(({ list, done, nextOffset }) => {
      store.add(list);
      store.setFetchedAll(done);
      if (typeof nextOffset === "number") {
        store.setOffset(nextOffset);
      }
      const page = parseInt((useRoute().query.page as string) || "0") + 1;
      useRouter().replace({ query: { ...useRoute().query, page } });
    })
    .finally(() => {
      fetching.value = false;
    });
};

await useAsyncData(async () => {
  if (getList.value.length === 0) {
    await fetch();
  }
  return getList.value;
});

useHead({
  title: "오이 소통공간 | 따분한 일상이 바뀌는 순간",
  link: [{ rel: "canonical", href: "https://oe-app.com/gathering/feed/list" }],
  script: [
    {
      type: "application/ld+json",
      children: JSON.stringify({
        "@context": "https://schema.org",
        "@graph": [
          organizationSchema,
          softwareAppSchema,
          gatheringFeedListPageSchema(
            getList.value.map((feed) => ({
              id: feed.id,
              content: feed.description,
              author: {
                id: feed.author.id,
                name: feed.author.nickname,
                profileImage: feed.author.image,
              },
              thumbnailImage:
                typeof feed.image === "string"
                  ? feed.image
                  : feed.image.thumbnailUrl,
              publishDate: feed.createdAt.toISOString(),
              likeCount: feed.likeCount,
              commentCount: feed.commentCount,
            }))
          ),
        ],
      }),
    },
  ],
});

onMounted(() => {
  window.addEventListener("scroll", handleScrollEvent);

  removeBeforeEach = useRouter().beforeEach((to, from) => {
    if (to.name !== "gathering-feed-id" && to.path !== from.path) {
      store.clear();
    }
  });
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleScrollEvent);
  removeBeforeEach && removeBeforeEach();
});

const handleScrollEvent = (e: Event) => {
  const scrollTop = window.scrollY;
  const viewportHeight = window.innerHeight;
  const fullHeight = document.documentElement.scrollHeight;

  if (scrollTop + viewportHeight >= fullHeight - 100) {
    fetch();
  }
};

const goTo = (path: string) => {
  useRouter().push(path);
};

const replaceTo = (path: string) => {
  useRouter().replace(path);
};
</script>

<style scoped>
@import "@/assets/css/seo.css";
@import "@/assets/css/base.css";
</style>
